import React, { Component } from "react";
import arrayStar from "../../../../data/arrayStar";
import "./ModalMantenimiento.scss";

export default class ModalMantenimiento extends Component {

  showCondition=()=>{
    if (parseInt(document.getElementsByName('distanceSelected')[0].value.split('km')[0])<=150){
      return (
        <div>
        <div className="flexd ">
        <p className="toyota-life"><b>Servicio exclusivo para particulares:</b><span className="text-red"> Toyota Relax</span></p>
        <div   className=" li-item.ng-star-inserted">

                <div className="rowFlex">
                   <img className="checkSize"alt="check"src="images/check.png"/>
                    <div className=" li-item.ng-star-inserted">{" "}Extensión de garantía GRATIS válida por 1 año ó 15.000 kms ó 20.000 kms*</div>
                </div>
               
        </div>
        
          </div>
          <p className="condiciones">*Consulta condiciones en <a href="https://www.toyota.es/terminos-y-condiciones-toyota-life">https://www.toyota.es/terminos-y-condiciones-toyota-life</a>  o en tu taller oficial.</p>            
          </div>
      );
    }
    else return
  }

  showAdBlueDescription=()=>{
    if (this.props.precioNoIncluyeAdblue){
      return (
          <div>
            <p className="ad-blueP">
            El precio no incluye AD-BLUE.
          </p>
        </div>
      );
    }
    else return
  }

  render() {
    return (
      <div
        className="modal fade"
        id="queIncluyeMantenimiento"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-lg"
          role="document"
          style={{ top: this.props.parentPosition }}
        >
          <div className="modal-content">
            <div className="modal-header">
              {/* <h5 className="modal-title" style={{ marginTop: 'auto', marginBottom: 'auto' }}>Operaciones de mantenimiento</h5> */}
              <h5 className="modal-title" style={{ marginTop: 'auto', marginBottom: 'auto' }}>
                <span style={{ fontSize: 24 }}>Operaciones de mantenimiento</span>
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="flexd modal-body li-item.ng-star-inserted">
              <h2 className="paddingTB ng-star-inserted">Verificación</h2>
              <div className="li-item.ng-star-inserted ">
                {this.props.thingsToDo
                  ? this.props.thingsToDo.map((piece, i) => {
                      if (piece.cTipo.includes("V")) {
                        return (
                          <div key={i + "Vcheck"} className="rowFlex">
                            {" "}
                            <img
                              key={i + "VcheckImg"}
                              className="checkSize"
                              alt="check"
                              // src="images/Ico-Check.png"
                              src="images/pngegg.png"
                            />{" "}
                            <div
                              key={i + "VcheckMan"}
                              className="li-item.ng-star-inserted custom-feature"
                            >
                              {piece.cDescripcion}
                            </div>
                          </div>
                        );
                        // if (arrayStar.includes(piece.cDescripcion)) {
                        //   return (
                        //     <div key={i + "Vcheck"} className="rowFlex">
                        //       {" "}
                        //       <img
                        //         key={i + "VstarImg"}
                        //         className="starSize"
                        //         alt="star"
                        //         src="images/star.png"
                        //       />{" "}
                        //       <div
                        //         key={i + "VstarMan"}
                        //         className=" li-item.ng-star-inserted "
                        //       >
                        //         {piece.cDescripcion}
                        //       </div>
                        //     </div>
                        //   );
                        // } else {
                        //   return (
                        //     <div key={i + "Vcheck"} className="rowFlex">
                        //       {" "}
                        //       <img
                        //         key={i + "VcheckImg"}
                        //         className="checkSize"
                        //         alt="check"
                        //         src="images/Ico-Check.png"
                        //       />{" "}
                        //       <div
                        //         key={i + "VcheckMan"}
                        //         className="li-item.ng-star-inserted "
                        //       >
                        //         {piece.cDescripcion}
                        //       </div>
                        //     </div>
                        //   );
                        // }
                      }
                    })
                  : null}
                {/* <div key={"Vcheck"} className="rowFlex">
                  <img className="starSize" alt="star" src="images/star.png" />
                  <div className=" li-item.ng-star-inserted ">
                    <b>Inspección del estado de salud del vehículo (componentes mecánicos y electrónicos).</b>
                  </div>
                </div> */}
                {/* {this.props.fuelSelected === "Híbrido" && (
                  <div key={"Vcheck"} className="rowFlex">
                    <img
                      className="starSize"
                      alt="star"
                      src="images/star.png"
                    />
                    <div className=" li-item.ng-star-inserted ">
                      <b>Chequeo Integral del Sistema Híbrido.</b>
                    </div>
                  </div>
                )} */}
                
              </div>
              
              <div className="flexd " style={{marginTop: 15}}>
                <h2 className="paddingTB">Reemplazo</h2>
                <div>
                  {this.props.thingsToDo
                    ? this.props.thingsToDo.map((piece, y) => {
                        if (piece.cTipo.includes("R")) {
                            return (
                              <div key={y + "Rcheck"} className="rowFlex">
                                {" "}
                                <img
                                  key={y + "RcheckImg"}
                                  className="checkSize"
                                  alt="check"
                                  src="images/pngegg.png"
                                />{" "}
                                <div
                                  key={y + "RcheckMan"}
                                  className=" li-item.ng-star-inserted custom-feature"
                                >
                                  {piece.cDescripcion}
                                </div>
                              </div>
                            );

                          // if (arrayStar.includes(piece.cDescripcion)) {
                          //   return (
                          //     <div key={y + "Rstar"} className="rowFlex">
                          //       <img
                          //         key={y + "RstarImg"}
                          //         className="starSize"
                          //         alt="star"
                          //         src="images/star.png"
                          //       />
                          //       <div
                          //         key={y + "RstarMan"}
                          //         className=" li-item.ng-star-inserted "
                          //       >
                          //         {piece.cDescripcion}
                          //       </div>
                          //     </div>
                          //   );
                          // } else {
                          //   return (
                          //     <div key={y + "Rcheck"} className="rowFlex">
                          //       {" "}
                          //       <img
                          //         key={y + "RcheckImg"}
                          //         className="checkSize"
                          //         alt="check"
                          //         src="images/check.png"
                          //       />{" "}
                          //       <div
                          //         key={y + "RcheckMan"}
                          //         className=" li-item.ng-star-inserted "
                          //       >
                          //         {piece.cDescripcion}
                          //       </div>
                          //     </div>
                          //   );
                          // }
                        }
                      })
                    : null}
                </div>
              </div>
              
              {this.props.thingsToDo && this.props.thingsToDo.some((piece) => piece.cTipo.includes('L')) &&
                <div className="flexd " style={{marginTop: 15}}>
                  <h2 className="paddingTB">Limpieza</h2>
                  <div>
                    {this.props.thingsToDo.map((piece, y) => {
                        if (piece.cTipo.includes("L")) {
                            return (
                              <div key={y + "Rcheck"} className="rowFlex">
                                {" "}
                                <img
                                  key={y + "RcheckImg"}
                                  className="checkSize"
                                  alt="check"
                                  src="images/pngegg.png"
                                />{" "}
                                <div
                                  key={y + "RcheckMan"}
                                  className=" li-item.ng-star-inserted custom-feature"
                                >
                                  {piece.cDescripcion}
                                </div>
                              </div>
                            );
                          }
                        })
                      }
                  </div>
                  <br></br>
                </div>                
              }

              {/* <div className="flexd ">
                <h2 className="paddingTB">Limpieza</h2>
                <div>
                  {this.props.thingsToDo
                    ? this.props.thingsToDo.map((piece, y) => {
                        if (piece.cTipo.includes("L")) {
                            return (
                              <div key={y + "Rcheck"} className="rowFlex">
                                {" "}
                                <img
                                  key={y + "RcheckImg"}
                                  className="checkSize"
                                  alt="check"
                                  src="images/pngegg.png"
                                />{" "}
                                <div
                                  key={y + "RcheckMan"}
                                  className=" li-item.ng-star-inserted custom-feature"
                                >
                                  {piece.cDescripcion}
                                </div>
                              </div>
                            );
                        }
                      })
                    : null}
                </div>
              </div>
              <br></br> */}
             
              {/* {this.showCondition()} */}
             
              {/* {this.showAdBlueDescription()} */}

              
            </div>
            {/* <div className="modal-footer">
              <img
                className="star-footer"
                src="images/star.png"
                alt="starDiferencia"
              />
              <p className="modal-footerP">
                
                Estas son las operaciones que nos diferencian
              </p>
            </div> */}
            
          </div>
        </div>
      </div>
    );
  }
}
